import { render, staticRenderFns } from "./collapse.vue?vue&type=template&id=31409794&scoped=true&"
import script from "./collapse.vue?vue&type=script&lang=js&"
export * from "./collapse.vue?vue&type=script&lang=js&"
import style0 from "./collapse.vue?vue&type=style&index=0&id=31409794&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31409794",
  null
  
)

export default component.exports